import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import BusinessFormButtonsField from '../../components/business-form-buttons-field'
import BusinessFormTitle from '../../components/business-form-title'
import { useBusinessCreateContext } from '../../context/business-create-context'
import { useBusinessCreateStore } from '../../store/business-create-store'

const LocationTypeSchema = z.object({
  desiredLocationType: z.enum(['exact', 'general', 'not sure']),
})
type LocationTypeSchemaType = z.infer<typeof LocationTypeSchema>

export default function BusinessCreateLocationTypeStep() {
  const { setFormData, formData } = useBusinessCreateStore()
  const { handleNext, setFooterConfig } = useBusinessCreateContext()

  const form = useForm<LocationTypeSchemaType>({
    resolver: zodResolver(LocationTypeSchema),
    defaultValues: {
      desiredLocationType: formData.desiredLocationType || undefined,
    },
  })

  const onSubmit = (data: LocationTypeSchemaType) => {
    if (data.desiredLocationType === 'not sure') {
      handleNext(1)
      return
    }
    setFormData({ ...formData, desiredLocationType: data.desiredLocationType })
    handleNext()
  }

  const onLocationTypePress = () => {
    form.handleSubmit(onSubmit)()
  }

  useEffect(() => {
    setFooterConfig({
      buttonText: 'Skip',
      buttonVariant: 'ghost',
      primaryAction: () => handleNext(1),
    })
  }, [handleNext, setFooterConfig])

  return (
    <div className="flex size-full flex-col items-center justify-center gap-8">
      <div className="flex max-w-[500px] flex-col items-center text-center">
        <BusinessFormTitle>What is {formData.consumerFirstName} looking for?</BusinessFormTitle>
      </div>
      <form id="business-create-form" onSubmit={form.handleSubmit(onSubmit)} className="w-full">
        <BusinessFormButtonsField
          options={[
            { label: 'Specific location', subtitle: 'Property address', value: 'exact' },
            { label: 'General location', subtitle: 'City, state or postal code', value: 'general' },
            { label: 'Not sure!', value: 'not sure' },
          ]}
          control={form.control}
          name="desiredLocationType"
          onPress={onLocationTypePress}
        />
      </form>
    </div>
  )
}
